import React, { useState, useEffect } from "react";

// reactstrap components
import { Button, Container } from "reactstrap";

// core components

function LandingPageHeader() {
  let pageHeader = React.createRef();
  const [isVisible, setIsVisible] = useState(false);
  const [particleCount, setParticleCount] = useState(30);

  React.useEffect(() => {
    setIsVisible(true);
    
    if (window.innerWidth < 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  }, []);

  return (
    <>
      <div
        style={{
          background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
          minHeight: '100vh',
          paddingTop: '180px',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center'
        }}
        className="page-header"
        data-parallax={true}
        ref={pageHeader}
      >
        {/* Animated Background Particles */}
        {[...Array(particleCount)].map((_, i) => (
          <div
            key={i}
            style={{
              position: 'absolute',
              width: Math.random() * 8 + 3 + 'px',
              height: Math.random() * 8 + 3 + 'px',
              background: `rgba(255, 255, 255, ${Math.random() * 0.6 + 0.2})`,
              borderRadius: '50%',
              left: Math.random() * 100 + '%',
              top: Math.random() * 100 + '%',
              animation: `float ${Math.random() * 15 + 10}s infinite linear`,
              animationDelay: Math.random() * 15 + 's'
            }}
          />
        ))}

        {/* Floating Icons */}
        <div style={{
          position: 'absolute',
          top: '15%',
          left: '8%',
          animation: 'bounce 4s infinite'
        }}>
          <i className="fa fa-rocket" style={{ 
            fontSize: '50px', 
            color: 'rgba(255,255,255,0.3)',
            animation: 'pulse 3s infinite'
          }} />
        </div>
        
        <div style={{
          position: 'absolute',
          top: '25%',
          right: '10%',
          animation: 'bounce 4s infinite 1s'
        }}>
          <i className="fa fa-star" style={{ 
            fontSize: '45px', 
            color: 'rgba(255,255,255,0.3)',
            animation: 'pulse 3s infinite 0.5s'
          }} />
        </div>
        
        <div style={{
          position: 'absolute',
          bottom: '20%',
          left: '12%',
          animation: 'bounce 4s infinite 2s'
        }}>
          <i className="fa fa-diamond" style={{ 
            fontSize: '40px', 
            color: 'rgba(255,255,255,0.3)',
            animation: 'pulse 3s infinite 1s'
          }} />
        </div>

        <div style={{
          position: 'absolute',
          bottom: '30%',
          right: '8%',
          animation: 'bounce 4s infinite 0.5s'
        }}>
          <i className="fa fa-heart" style={{ 
            fontSize: '35px', 
            color: 'rgba(255,255,255,0.3)',
            animation: 'pulse 3s infinite 1.5s'
          }} />
        </div>

        {/* Gradient Orbs */}
        <div style={{
          position: 'absolute',
          top: '-100px',
          right: '-100px',
          width: '300px',
          height: '300px',
          background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
          borderRadius: '50%',
          animation: 'rotate 20s linear infinite'
        }}></div>
        
        <div style={{
          position: 'absolute',
          bottom: '-150px',
          left: '-150px',
          width: '400px',
          height: '400px',
          background: 'radial-gradient(circle, rgba(240, 147, 251, 0.1) 0%, transparent 70%)',
          borderRadius: '50%',
          animation: 'rotate 25s linear infinite reverse'
        }}></div>

        <div className="filter" style={{
          background: 'rgba(0,0,0,0.1)',
          backdropFilter: 'blur(1px)'
        }} />
        
        <Container style={{ position: 'relative', zIndex: 2 }}>
          <div 
            className="motto text-center"
            style={{
              transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
              opacity: isVisible ? 1 : 0,
              transition: 'all 1s ease-out'
            }}
          >
            <div style={{
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '30px',
              padding: '60px 40px',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.2)',
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
              marginBottom: '40px'
            }}>
              <h1 style={{
                background: 'linear-gradient(45deg, #ff6b6b, #feca57, #4facfe)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontSize: '5rem',
                fontWeight: '900',
                marginBottom: '20px',
                textShadow: '0 4px 8px rgba(0,0,0,0.3)'
              }}>
                <b>Tri-Advise</b>
              </h1>
              
              <div style={{
                width: '150px',
                height: '4px',
                background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                margin: '0 auto 30px',
                borderRadius: '2px'
              }}></div>
              
              <h3 style={{
                color: 'rgba(255,255,255,0.95)',
                fontSize: '2.2rem',
                fontWeight: '600',
                marginBottom: '40px',
                textShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }}>
                Building Better Brands.
              </h3>
              
              <p style={{
                color: 'rgba(255,255,255,0.9)',
                fontSize: '1.3rem',
                maxWidth: '600px',
                margin: '0 auto 50px',
                lineHeight: '1.6',
                textShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }}>
                Transform your business with our innovative digital marketing solutions. 
                We create exceptional experiences that drive growth and success.
              </p>
            </div>
            
            <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              href="/nfc"
              target="_blank"
                className="btn-round"
                style={{
                  background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                  border: 'none',
                  padding: '18px 40px',
                  borderRadius: '30px',
                  color: 'white',
                  fontWeight: '700',
                  fontSize: '1.2rem',
                  boxShadow: '0 10px 30px rgba(255, 107, 107, 0.4)',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'scale(1.05)';
                  e.target.style.boxShadow = '0 15px 40px rgba(255, 107, 107, 0.6)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = '0 10px 30px rgba(255, 107, 107, 0.4)';
                }}
              >
                <i className="fa fa-play" style={{ marginRight: '10px' }} />
              Get your NFC Business Card
            </Button>
              
            <Button
              href="/course"
              target="_blank"
              className="btn-round"
                style={{
                  background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
                  border: 'none',
                  padding: '18px 40px',
                  borderRadius: '30px',
                  color: 'white',
                  fontWeight: '700',
                  fontSize: '1.2rem',
                  boxShadow: '0 10px 30px rgba(79, 172, 254, 0.4)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'scale(1.05)';
                  e.target.style.boxShadow = '0 15px 40px rgba(79, 172, 254, 0.6)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = '0 10px 30px rgba(79, 172, 254, 0.4)';
                }}
              >
                <i className="fa fa-download" style={{ marginRight: '10px' }} />
                Enroll in Our Digital Marketing Course
            </Button>
            </div>

            {/* Clean Stats Section */}
            <div style={{ 
              display: 'flex', 
              gap: '60px', 
              marginTop: '80px',
              marginBottom: '60px',
              flexWrap: 'wrap',
              justifyContent: 'center'
            }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  fontSize: '3rem',
                  fontWeight: '800',
                  color: '#feca57',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                  marginBottom: '10px'
                }}>500+</div>
                <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', fontWeight: '600' }}>Happy Clients</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  fontSize: '3rem',
                  fontWeight: '800',
                  color: '#ff6b6b',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                  marginBottom: '10px'
                }}>1000+</div>
                <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', fontWeight: '600' }}>Projects Completed</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  fontSize: '3rem',
                  fontWeight: '800',
                  color: '#4facfe',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                  marginBottom: '10px'
                }}>5+</div>
                <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', fontWeight: '600' }}>Years Experience</div>
              </div>
            </div>
          </div>
        </Container>

        {/* CSS Animations */}
        <style jsx>{`
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-30px) rotate(180deg); }
          }
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
            40% { transform: translateY(-20px); }
            60% { transform: translateY(-10px); }
          }
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
          }
          @keyframes rotate {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </>
  );
}

export default LandingPageHeader;